import React, { useMemo, useRef } from "react";
import { defaultWebchatOptions, IAppState, WebchatOptions } from "../../Redux/reduxState";
import { connect } from "react-redux";
import { mergeStyles, mergeStyleSets } from '@fluentui/merge-styles';
import { useEffect } from "react";
import { FC } from "react";
import { Dispatch, AnyAction } from 'redux';
import { actionTypes, genericSingleAction } from "../../Redux/actions";
import { SnippetExperience } from "../../utilities/types";



declare const DruidWebchat_v2: {
  [key: string]: any;
  take: (actionType: string) => any;
};
////////////////// Styling //////////////////

let WebChatContainerClassName = mergeStyles(
  {
    height: '70vh',
    margin: '20px 25px'
  }
);

let WebChatPaneClassName = mergeStyles(
  {
    height: '82vh',
    maxHeight: 'calc(100vh - var(--webchat-editor-chrome-height))',
    padding: '30px 20px'
  }
);

////////////////// WebChat //////////////////

interface StateProps {
  webchatOptions: WebchatOptions;
  editorMode: SnippetExperience;
  getState: () => IAppState
}

interface DispatchProps {
  updateStyleOptions: (value: any) => void,
}

interface Props {
  botId: string; 
  baseUrl: string;
  currentStyleOptions: Partial<WebchatOptions>;
}

type PropsType = StateProps & DispatchProps & Props;



export const WebChat: FC<PropsType> = (props) => {

  useEffect(() => {
    // const {styleOptions: toSetWebChatStyleOptions } = DruidWebchat_v2.visitMergedChatOptions({ UI: {}, styleOptions: props.webChatStyleOptions});
    const defaultOptions = {
      botId: props.botId ||'0ddf3836-9857-4da5-a136-08d90fb74ba3',
      baseUrl:  props.baseUrl ||'https://druidapi.develop.druidplatform.com',
      snippetExperience: props.editorMode,
      // _loadConfigurationJSON: loadConfigurationValue,
      UI: {
        // parentElement: document.querySelector('.webchat-editor-container'),
        autoExpandEnabled: true,
        height: '80vh',
        bottom: '5%',
        fullScreenMode: false
        // headerOptions: {
        //   showReload: true
        // }
      },
    };

    // const mergedOptions = { ...props.webchatOptions, ...defaultOptions }
    const mergedOptions = {  ...defaultOptions }

    DruidWebchat_v2.init(mergedOptions);

    return () => {
      DruidWebchat_v2.destroy();
    }
  }, [props.botId, props.baseUrl]);

  useEffect(() => {
    const webchatState = DruidWebchat_v2.druidWebChatInstance?.getState?.();
    if (!webchatState) {
      return;
    }

    DruidWebchat_v2.druidDispatch({
      type: 'SET_MODE',
      payload: props.editorMode
    });
    if (webchatState.loaded) {
      DruidWebchat_v2.druidDispatch({ type: 'OPEN_WEBCHAT' });
    }
  }, [props.editorMode, props.botId, props.baseUrl]);

  const restylingsEnabledModified = useRef(false);
  const initialIsLoading = useRef(true);
  const latestProps = useRef(props);
  latestProps.current = props;
  useEffect(() => {
    DruidWebchat_v2.customGeneratorFunction = function* (action: any) {

      if (action.type === 'RESET') {
        const resetUI = action?.payload?.UI || {};
        const keepsEditorOptions = !("restylingsEnabled" in resetUI) && !("druidNewLayoutEnabled" in resetUI);

        yield DruidWebchat_v2.take('SET_LOADING');
        const { currentStyleOptions, editorMode } = latestProps.current;
        yield DruidWebchat_v2.put({ type: 'SET_MERGEDCHATOPTIONS', payload: { ...(keepsEditorOptions && currentStyleOptions), snippetExperience: editorMode } });
        yield DruidWebchat_v2.put({ type: 'SET_MODE', payload: editorMode });
      }

      if (action.type === 'SET_LOADING') {
        // if(restylingsEnabledModified.current !== true) {
        if(initialIsLoading.current === true) {
            // @ts-ignore
            const { payload } = yield DruidWebchat_v2.take('SET_LOADCONFIGURATIONRESULT');
            if(payload) {
              const result = defaultWebchatOptions(payload);
              props.updateStyleOptions(result);
              initialIsLoading.current = false;
            }
        } else {
          restylingsEnabledModified.current = false;
        }
        
      }
    };


    return () => {
      DruidWebchat_v2.customGeneratorFunction = null;
    }
  }, [props.webchatOptions]);
  return (
    <div className={WebChatPaneClassName}>
      <div className={`${WebChatContainerClassName} webchat-editor-container`}>
      </div>
    </div>
  );
}


////////////////// Redux //////////////////

const mapStateToProps = (state: IAppState, ownProps: Props): StateProps => ({
  webchatOptions: state.webchatOptions,
  editorMode: state.editorMode,
  getState: () => state
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchProps => ({
  updateStyleOptions: (value: any) => {
    dispatch(genericSingleAction<any>(actionTypes.UPDATE_STYLE_OPTIONS, value ));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WebChat);
